<div class="step_info"> 
  <p class="step_info_step_name">{{ stepInfo.activeStepNumber + 1 }}. {{ stepInfo.activeStepKeyName | translate }}</p>
</div>
